import React from "react";

const LOGO_URL = "/progere-crm-logo.png";

// Full brand logo image (monogram + wordmark)
export function Logo({ className = "h-32" }) {
  return (
    <img src={LOGO_URL} alt="PROGÈRE CRM" data-testid="progere-logo"
      className={`${className} w-auto object-contain select-none`} draggable="false" />
  );
}

// Text wordmark: PRO (or) · GÈRE (rouge) · CRM (blanc) — exact PROGÈRE branding
export function Wordmark({ className = "text-3xl" }) {
  return (
    <span className={`progere-brand-metal ${className}`} data-testid="progere-wordmark">
      <span className="progere-brand-prog">PRO</span>
      <span className="progere-brand-ere -ml-0.5">GÈRE</span>
      <span className="progere-brand-module">&nbsp;CRM</span>
    </span>
  );
}

// Header lockup identical to PROGÈRE PUNCH: badge + wordmark + "MODULE PROGÈRE ERP"
export function BrandLockup({ size = "text-2xl sm:text-3xl", center = true }) {
  return (
    <div className={`flex items-center gap-2.5 ${center ? "justify-center" : ""}`} data-testid="brand-lockup">
      <div className="h-12 w-12 rounded-xl bg-[#0b0b0b] border border-[#F2BC2E]/40 flex items-center justify-center shrink-0 overflow-hidden shadow-[0_2px_12px_rgba(242, 188, 46,0.16)]">
        <img src="/progere-crm-monogram.png" alt="PROGÈRE CRM" className="h-10 w-10 object-contain select-none" draggable="false" />
      </div>
      <div className="flex flex-col leading-none">
        <Wordmark className={`${size} pg-glow font-extrabold`} />
        <span className="mt-1.5 text-[9px] sm:text-[10px] tracking-[0.3em] uppercase font-semibold text-gray-500">Module PROGÈRE ERP</span>
      </div>
    </div>
  );
}
